import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import __isEmpty from 'lodash/isEmpty';
import { StickyContainer, Sticky } from 'react-sticky';

import butter from '../../services/butter-client';

import './Post.scss';
import './buttercms.scss';
import StartTrialAction from '../../components/StartTrialAction';
import PostListItem from '../../components/PostListItem';

const moment = require('moment');
const { detect, detectDevice } = require('../../services/detect-browser');
const deviceInfo = {
  browser: detect(),
  device: detectDevice()
};

class Post extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      post: {},
      relatedPosts: {}
    };

    this.goToSignUp = this.goToSignUp.bind(this);
  }

  componentDidMount() {
    const { match } = this.props;

    butter.post.retrieve(match.params.post).then((results) => {
      this.setState({ post: results.data.data });

      setTimeout(() => {
        window.dataLayer.push({
          'event': 'virtualPageView',
          'deviceType': deviceInfo.device,
          'deviceOS': deviceInfo.browser.os,
          'page': {
            'title': `Blog Page: ${results.data.data.title}`,
            'url': this.props.location.pathname,
          }
        });
      }, 0);

      this.getRelatedPosts(this.state.post.categories[0]);
    });
  }

  goToSignUp(e, mpEvent) {
    if (this.context.mixpanel) {
      this.context.mixpanel.track(mpEvent, { page: 'Single Post', title: this.state.post.title });
    }
    window.open( process.env.REACT_APP_ACCOUNTS_BASE_URL, '_blank');
  }

  getRelatedPosts(related) {
    butter.category.retrieve(related.slug, { include: 'recent_posts' }).then((response) => {
      this.setState({ relatedPosts: response.data.data });
    });
  }

  render() {
    if (__isEmpty(this.state.post) || __isEmpty(this.state.relatedPosts)) {
      return <div />
    }

    const post = this.state.post;
    const relatedPosts = this.state.relatedPosts;

    return (
      <div className="app">
        <Helmet>
          <title>{`${post.seo_title} | codeSpark Blog`}</title>
          <meta name="description" content={post.meta_description} />
          <meta name="keywords" content="Kids coding languages, Hour of code, coding for kids, kids apps, kids games, learn to code, STEM, Reading, Math, Elementary school" />
          <meta property="og:title" content={post.seo_title} />
          <meta property="og:description" content={post.meta_description} />
          <meta name="twitter:card" content="app" />
          <meta name="twitter:site" content="@codesparkapp" />
          <meta name="twitter:description" content="Learn-to-code Tips for Teachers and Parents from codeSpark Academy. Don't miss out on the Foo Fun in codeSpark Academy." />
          <meta name="twitter:app:country" content="US" />
          <meta name="twitter:app:id:iphone" content="923441570" />
          <meta name="twitter:app:id:ipad" content="923441570" />
          <meta name="twitter:app:id:googleplay" content="org.codespark.thefoos" />
        </Helmet>
        <div ref={(ref) => this._div = ref} />
        <div className="page single-post-page">
          <div className="single-post">
            {/* <div className="post-featured-image" style={{ backgroundImage: `url(${post.featured_image})` }}></div> */}
            <div className="post-content">
              <StickyContainer className="social-container large-social">
                <Sticky topOffset={-100} bottomOffset={200}>
                  {
                    ({ isSticky, wasSticky, style, distanceFromTop, distanceFromBottom, calculatedHeight }) => {
                      return (
                        <div className="inner" style={{ ...style, marginTop: isSticky ? '160px' : '20px' }}>
                          <img alt="" className="rocket-img" src="https://thefoos-com.s3.amazonaws.com/blog/post/rocket.png" aria-hidden="true" />
                          <p className="share-text">Share this post:</p>
                          <ul>
                            <a href={`https://www.facebook.com/sharer/sharer.php?u=${`${process.env.REACT_APP_BLOG_BASE_URL}/posts/${post.slug}`}`} target="_blank" rel="noopener noreferrer">
                              <li><i className="fa fa-facebook-official" aria-hidden="true"></i></li>
                            </a>
                            <a href={`https://twitter.com/intent/tweet?url=${process.env.REACT_APP_BLOG_BASE_URL}/posts/${post.slug}`} target="_blank" rel="noopener noreferrer">
                              <li><i className="fa fa-twitter" aria-hidden="true"></i></li>
                            </a>
                          </ul>
                        </div>
                      )
                    }
                  }
                </Sticky>
              </StickyContainer>
              <div className="social-container small-social">
                <p className="share-text">Share this post:</p>
                <ul className="horizontal">
                  <a href={`https://www.facebook.com/sharer/sharer.php?u=${`${process.env.REACT_APP_BLOG_BASE_URL}/posts/${post.slug}`}`} target="_blank" rel="noopener noreferrer">
                    <li><i className="fa fa-facebook-official" aria-hidden="true"></i></li>
                  </a>
                  <a href={`https://twitter.com/intent/tweet?url=${process.env.REACT_APP_BLOG_BASE_URL}/posts/${post.slug}`} target="_blank" rel="noopener noreferrer">
                    <li><i className="fa fa-twitter" aria-hidden="true"></i></li>
                  </a>
                </ul>
              </div>
              <div className="content">
                <div>
                  <h1 className="post-title">{post.title}</h1>
                  <p className="post-date">{moment(post.published).format('MM/DD/YYYY')}</p>
                  <div dangerouslySetInnerHTML={{ __html: post.body }} />
                </div>
                {
                  post.tags.length > 0 &&
                  <div className="post-tags">
                    <h1>Article Tags</h1>
                    <hr />
                    <ul className="tag-list">
                      {
                        post.tags.map((tag, key) => {
                          return (
                            <li key={key}>
                              <div className="tag-wrapper-component">
                                <Link to={`/tag/${tag.slug}`}>{ tag.name }</Link>
                              </div>
                            </li>
                          )
                        })
                      }
                    </ul>
                  </div>
                }
                {
                  relatedPosts.recent_posts.length > 0 &&
                  <div className="related-posts">
                    <h1>Related Articles</h1>
                    <hr />
                    <div className="related-list">
                      {
                        relatedPosts.recent_posts.map((post, key) => {
                          return (
                            <PostListItem key={key} layout="related" post={post} />
                          )
                        })
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <StartTrialAction onButtonClick={(e) => this.goToSignUp(e, 'Blog Action: Start Trial Clicked - In-Page')} />
        </div>
      </div>
    );
  }
}

export default withRouter(Post);
